export default {
  //首页钢材
  serialNoWidth: 120, // 序号
  titleWidth: 320, //标题
  //详情
  equipmentDescWidth: 280, //设备物资说明
  operationWidth: 180 //操作
};
